<template>
  <div>
           <vue-headful
            title="Update Billing Address - Girish Jewellers"
            description="Update Billing Address, girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
                  
                  
                  
                    <article class="content span12">
                      <div class="title-box no-margin">
                        <h1 class="title">Update Billing Address</h1>
                      </div>
                <ul id="checkoutsteps" class="clearfix">
                    <li class="active">
                    
                    <div class="step-content">
                        <div class="col2-set clearfix">
                        <div class="col-1">
                            <h3 class="title">Personal Information</h3>
                            
                            <label>First Name: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.first_name.$error }">
                            <input class="input-block-level" id="first_name" name="first_name" type="text"  maxlength="100" v-model.trim="$v.results.Profile.first_name.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.first_name.$dirty && !$v.results.Profile.first_name.required">
                              First name is required
                            </span>

                            <label>Last Name: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.last_name.$error }">
                            <input class="input-block-level" id="last_name" name="last_name" type="text"  maxlength="100" v-model.trim="$v.results.Profile.last_name.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.last_name.$dirty && !$v.results.Profile.last_name.required">
                              Last name is required
                            </span>
                            
                            <label>Contact No.: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.phone.$error }">
                            <input class="input-block-level" id="phone" name="phone" type="text"  maxlength="50" v-model.trim="$v.results.Profile.phone.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.phone.$dirty && !$v.results.Profile.phone.required">
                              Contact no. is required
                            </span>                            
                            
                            <label>Email: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.email.$error }">
                            <input class="input-block-level" id="email" name="email" type="email"  maxlength="100" v-model.trim="$v.results.Profile.email.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.email.$dirty && !$v.results.Profile.email.required">
                              Email is required
                            </span>                            
                            <span class="invalid-mesage" v-if="$v.results.Profile.email.$invalid">
                             Invalid email address
                            </span>
                            
                            <label>Address: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.address1.$error }">
                            <input class="input-block-level" placeholder="Address first line" id="address1" name="address1" type="text"  maxlength="250" v-model.trim="$v.results.Profile.address1.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.address1.$dirty && !$v.results.Profile.address1.required">
                              Address is required
                            </span>                            
                            <input class="input-block-level" placeholder="Address second line" id="address2" name="address2" type="text"  maxlength="250" v-model.trim="$v.results.Profile.address2.$model">	                            

                            <!-- .checkout-login -->
                            <div class="clearfix"></div>
                            <div class="buttons-box clearfix">
                            
                            </div><!-- .buttons-box -->                                
                        </div>
                        <div class="col-2">
                            <h3 class="title">Location Details</h3>

<label>City: <span class="required">*</span></label>
<div :class="{ 'invalid': $v.results.Profile.city_name.$error }">
<input class="input-block-level" placeholder="City" id="city_name" name="city_name" type="text"  maxlength="100" v-model.trim="$v.results.Profile.city_name.$model">	
</div>
<span class="invalid-mesage" v-if="$v.results.Profile.city_name.$dirty && !$v.results.Profile.city_name.required">
  City is required
</span>                            

<label>Pincode: <span class="required">*</span></label>
<div :class="{ 'invalid': $v.results.Profile.zip.$error }">
<input class="input-block-level" placeholder="Pincode" id="zip" name="zip" type="text"  maxlength="15" v-model.trim="$v.results.Profile.zip.$model">	
</div>
<span class="invalid-mesage" v-if="$v.results.Profile.zip.$dirty && !$v.results.Profile.zip.required">
  Pincode is required
</span>                            

<label>State: <span class="required">*</span></label>
<div :class="{ 'invalid': $v.results.Profile.state_name.$error }">
<input class="input-block-level" placeholder="State" id="state_name" name="state_name" type="text"  maxlength="100" v-model.trim="$v.results.Profile.state_name.$model">	
</div>
<span class="invalid-mesage" v-if="$v.results.Profile.state_name.$dirty && !$v.results.Profile.state_name.required">
  State is required
</span>                            

<label>Country: <span class="required">*</span></label>
<div :class="{ 'invalid': $v.results.Profile.country_id.$error }">
<select class="input-block-level" style="font-size:16px;" id="country_id" name="country_id" v-model.trim="$v.results.Profile.country_id.$model">	
  <option v-for="country in results.Countries" :key="country.id" :value="country.id">{{ country.country_name }}</option>
</select>
</div>
<span class="invalid-mesage" v-if="$v.results.Profile.country_id.$dirty && !$v.results.Profile.country_id.required">
  Country is required
</span>                            

                            <div class="buttons-box clearfix">
                              <button  type="button"  class="btn" v-on:click="submit" id="btnsubmit" name="btnsubmit">Save</button>
                              <button  type="button"  class="btn" v-on:click="$router.push('/checkout')" id="btncancel" name="btncancel">Cancel</button>
                            <span class="required"><b>*</b> Required Field</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    </li>
                    </ul>
                    <br><br><br><br>
                    </article>
                </div>
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import { required, email} from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate';
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';

Vue.use(Vuelidate)

export default {
  name: 'UpdateBillingAddress',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
    this.getSession;
    this.getBillingAddress;
    this.getCountry;
  },
  computed:mapGetters(["Session","BillingAddress","Country"]),
  watch:{
    Country(newValue) {
      this.results.Countries = newValue;
    },
    Session(newValue) {
      if(!newValue.is_login){
          Common.showError("Please login to access account.");
          this.$router.push("/login");
        }
      },
    BillingAddress(newValue) {      
      
        this.results.Profile = newValue;
    }
},
beforeMount :function(){
      $("#first_name").focus();
      //Common.preparValidator(this.$v,'results');
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: { Profile:{first_name:"",last_name:"",phone:"",email:"",address1:"",address2:"",zip:"",city_name:"",state_name:"",country_id:"99",country_name:"India"},Countries:{} } };
    },
    validations: {
      results: {Profile:{
          first_name: {
            required
          },
          last_name: {
            required
          },
          phone: {
            required
          },
          email: {
            required,
            email
          },          
          address1: {
            required,
          },
          address2: {
            
          },
          city_name: {
            required
          },
          zip: {
            required
          },
          state_name: {
            required
          },
          country_id: {
            required
          }      
      }
      } 
    },    
    methods:{
    ...mapActions(["getCountry","getSession","getBillingAddress","updateBillingAddress","loginSession"]),
      isMobile:function(){
   return Common.isMobile();
   },
   submit: function()
    {
        //this.errors.push("Name required.");
        //alert(this.results.$touch());

        this.$v.results.Profile.$touch();
        //alert(JSON.stringify(this.$v.results.password));

        if (this.$v.results.Profile.$pending || this.$v.results.Profile.$error) 
        {

          Common.showError("Invalid input, Please check the entered values again.");
          // 1. Loop the keys
            for (let key in Object.keys(this.$v.results.Profile)) {
              // 2. Extract the input
              const input = Object.keys(this.$v.results.Profile)[key];
              // 3. Remove special properties
              if (input.includes("$")) return false;
              // 4. Check for errors

              if (this.$v.results.Profile[input].$error) {
                // 5. Focus the input with the error
                $("#" + input).focus();

                // 6. Break out of the loop
                break;
              }

            }

          return;
        }
      // to form submit after this
      //Common.callServerFunction("Users/UserController::Login",this.get_submit_response,this.results,"Users");
      //Common.startAjaxLoader();
      
      this.updateBillingAddress(this.results.Profile);
      this.$router.push("/checkout");
      
    //Common.showValidation(["Name required.","Address required.","Surname required."]);        
      },onResize: function() {
    },
      loadOnMount: function() {
        this.getCountry();
        this.getSession();
        this.getBillingAddress();
        $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>